export default function MaintenancePage({ message }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#F5F0EB] px-4">
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="w-20 h-20 bg-[#3D348B]/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-[#3D348B]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
            />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </div>

        {/* Brand */}
        <h1 className="text-2xl font-bold text-[#3D348B] mb-2 tracking-wide">Kawkad</h1>

        {/* Title */}
        <h2 className="text-xl font-semibold text-gray-800 mb-3">Penyelenggaraan Sedang Dijalankan</h2>

        {/* Message */}
        <p className="text-gray-500 text-sm leading-relaxed">
          {message || "Laman web sedang dalam penyelenggaraan. Sila cuba sebentar lagi."}
        </p>

        {/* Divider */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-400">Hubungi kami jika ada sebarang pertanyaan</p>
        </div>
      </div>
    </div>
  );
}
